import load from '@/utils/fangcloud-loader'

// http://qdas.bi.qihoo.net/sdk/index.php?r=web/index&menuid=201

function _track (type) {
  return function (event) {
    return new Promise(function (resolve, reject) {
      let isValide = false
      switch (type) {
        case 'click': // 自定义click事件
          if (event && event.target) {
            let params = {
              cId: window.monitor.util.getContainerId(event.target),
              c: window.monitor.util.getText(event.target)
            }
            window.monitor.log(params, type)
            isValide = true
          }
          break
      }
      resolve(isValide)
    })
  }
}

export default {
  scriptLoader () {
    load.js('https://s5.ssl.qhres2.com/!c2c090e2/monitor_analytic.js').then(_ => {
      window.monitor.setProject('QH_388_3').getTrack().getClickAndKeydown().getClickHeatmap(10, 1)
    })
  },
  click: _track('click')
}
